import {Injectable} from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {CurrencyResponse} from "../interface/currencyResponse";

@Injectable({
  providedIn: 'root',
})
export class CurrencyService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {
  }

  getCurrency(currency: string): Observable<CurrencyResponse> {
    const params: { [key: string]: string } = {
      isoCode: currency
    };
    return this.http.get<CurrencyResponse>(`${this.apiUrl}/currency`, {params});
  }

}
